import { Stack } from 'expo-router';

/**
 * Profile tab stack: the profile dashboard (`index`) and the body-composition
 * trend screen (`body-composition`). Living inside the `(tabs)` navigator keeps
 * the bottom tab bar visible on the trend screen — and, crucially, stops
 * `body-composition` from registering as its own stray bottom tab (expo-router
 * auto-adds every unnested route in a `Tabs` navigator as a tab).
 */
export default function ProfileLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="body-composition" />
    </Stack>
  );
}
